export default "__VITE_ASSET__Z1lr$GXn__"